var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import client from "@irati/utils/services/apollo";
import PBService from "@irati/utils/services";
import rewardErrorHandler from "@irati/reward/services/errors/rewardErrorHandler";
import createRecognitionMutation from "./mutations/CreateRecognition";
import updatePollWithRewardIdMutation from "./mutations/UpdatePollWithReward";
import updateRecognitionWithRewardMutation from "./mutations/UpdateRecognitionWithReward";
import recognitionErrorHandler from "./errors/recognitionErrorHandler";
var RecognitionService = /** @class */ (function (_super) {
    __extends(RecognitionService, _super);
    function RecognitionService() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RecognitionService.prototype.create = function (recognition) {
        return client.mutate({ mutation: createRecognitionMutation, variables: { recognition: recognition } }).then(function (_a) {
            var data = _a.data;
            return data.createRecognition;
        });
    };
    RecognitionService.prototype.updateRecognitionWithRewardId = function (recognitionId, orderId) {
        return client.mutate({ mutation: updateRecognitionWithRewardMutation, variables: { recognitionId: recognitionId, orderId: orderId } }).then(function (_a) {
            var data = _a.data;
            return data.updateRecognitionWithRewardId;
        });
    };
    RecognitionService.prototype.updatePollWithRewardId = function (pollId, orderId) {
        return client.mutate({ mutation: updatePollWithRewardIdMutation, variables: { pollId: pollId, orderId: orderId } }).then(function (_a) {
            var data = _a.data;
            return data.updatePollWithRewardId;
        });
    };
    return RecognitionService;
}(PBService));
var service = new RecognitionService({ errorHandlers: [recognitionErrorHandler, rewardErrorHandler] });
export default service;
